import React from "react";
import { styled } from "@mui/material/styles";
import { Breadcrumbs, Link } from "@mui/material";
import { Home } from "@mui/icons-material";

const classes = {
  link: "link",
  current: "current",
};

const BreadcrumbItem = styled("div")(() => ({
  [`& .${classes.link}`]: {
    display: "flex",
    textTransform: "uppercase",
    fontSize: "0.5rem",
    letterSpacing: "0.075rem",
    color: "#82786F",
    fontWeight: 500,
  },
  [`& .${classes.current}`]: {
    display: "flex",
    textTransform: "uppercase",
    fontSize: "0.5rem",
    letterSpacing: "0.075rem",
    color: "#82786F",
    fontWeight: 500,
  },
}));

interface LinkObject {
  text: string;
  href?: string;
  icon?: React.ReactNode;
  currentPage?: boolean;
}

interface AppBreadcrumbProps {
  links: LinkObject[];
}
const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ links }) => (
  <Breadcrumbs aria-label="breadcrumb" separator=">">
    {links.map((link) => (
      <BreadcrumbItem key={link.text}>
        {!link.currentPage && (
          <Link color="inherit" className={classes.link} href={link.href}>
            {link.href === "/" ? <Home /> : link.icon}
            {link.text}
          </Link>
        )}

        {link.currentPage && (
          <span className={classes.current}>{link.text}</span>
        )}
      </BreadcrumbItem>
    ))}
  </Breadcrumbs>
);

export default AppBreadcrumb;
